import { createSlice } from "@reduxjs/toolkit";
import { updateUserProfile } from "../../utils/localStorageUtil";

// Safely parse user data from localStorage
let parsedUser = null;
try {
  const storedUser = localStorage.getItem("userProfile");
  if (storedUser) {
    parsedUser = JSON.parse(storedUser);
  }
} catch (err) {
  console.warn("Invalid userProfile in localStorage:", err);
  // Optionally clear corrupted data
  localStorage.removeItem("userProfile");
}

export const userSlice = createSlice({
  name: "user",
  initialState: {
    user: parsedUser,
    isDark: false,
  },
  reducers: {
    setTheme: (state, action) => {
      state.isDark = action.payload;
    },
    toggleDarkTheme: (state) => {
      state.isDark = !state.isDark;
    },
    setUser: (state, action) => {
      state.user = action.payload;
      updateUserProfile(action.payload);
    },
    resetUser: (state) => {
      state.user = null;
      localStorage.removeItem("userProfile");
    },
  },
});

export const { setUser, resetUser, toggleDarkTheme, setTheme } = userSlice.actions;

export default userSlice.reducer;
